import React from "react";
const SvgNewTrash = props => (
  <svg viewBox="0 0 15 16" {...props}>
    <path
      fill="none"
      stroke="#697684"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M8.836 5.865v6.222-6.222zm-3.226 0v6.222-6.222zM2.383 2.953v10.6c0 .799.62 1.447 1.382 1.447h6.914c.764 0 1.383-.648 1.383-1.447v-10.6H2.383zm7.328-.45C9.711 1.673 9.068 1 8.275 1H6.17c-.794 0-1.438.673-1.438 1.503v.45H9.71v-.45zM1 2.953h12.444H1z"
    />
  </svg>
);
export default SvgNewTrash;
